/* tslint:disable */
import { ValueError } from "../../Errors/ValueError";
export class FEWSURL {
    constructor(params) {
        if (this.stringEmptyOrUndefined(params.locationIds))
            throw new ValueError(`Location ID: ${params.locationIds} empty or undefined`);
        if (params.endDateNumDaysInFuture === undefined || params.startDateNumDaysPrevious === undefined)
            throw new ValueError(`Start and end date must both be defined: ${params.locationIds} empty or undefined`);
        this.params = params;
        this.summarySeries = params.summarySeries;
    }
    stringEmptyOrUndefined(str) {
        return (str === undefined || str.length === 0);
    }
    /**
     * The API expects the date in a weird ISO format.
     * @param date
     * @returns
     */
    dateToAPIISOString(date) {
        return date.toISOString().split('.')[0] + "Z";
    }
    get startDate() {
        if (this.isRawDates !== undefined && this.isRawDates === true) {
            return this.dateToAPIISOString(this.rawStartDate);
        }
        else {
            let date = new Date();
            date.setDate(date.getDate() - this.params.startDateNumDaysPrevious);
            return this.dateToAPIISOString(date);
        }
    }
    get endDate() {
        if (this.isRawDates !== undefined && this.isRawDates === true) {
            return this.dateToAPIISOString(this.rawEndDate);
        }
        else {
            let date = new Date();
            date.setDate(date.getDate() + this.params.endDateNumDaysInFuture);
            return this.dateToAPIISOString(date);
        }
    }
    buildURL(baseURL) {
        let url = new URL(baseURL);
        url.searchParams.append("locationIds", this.params.locationIds);
        url.searchParams.append("moduleInstanceIds", this.params.moduleInstanceID);
        url.searchParams.append("startTime", this.startDate);
        url.searchParams.append("endTime", this.endDate);
        url.searchParams.append("documentFormat", "PI_JSON");
        url.searchParams.append("documentVersion", "1.25");
        url.searchParams.append("parameterIds", this.params.parameterIds);
        url.searchParams.append("useDisplayUnits", "false");
        url.searchParams.append("showThresholds", "true");
        url.searchParams.append("omitMissing", "false");
        url.searchParams.append("onlyHeaders", "false");
        url.searchParams.append("showEnsembleMemberIds", 'true');
        // this.params.forecast ? url.searchParams.append("forecast",this.params.forecast.toString()) : undefined;
        this.params.forecastCount ? url.searchParams.append("filterID", this.params.forecastCount.toString()) : undefined;
        this.params.filterId ? url.searchParams.append("filterId", this.params.filterId) : undefined;
        this.params.externalForecastTime ? url.searchParams.append("externalForecastTimes", this.params.externalForecastTime) : undefined;
        this.params.convertDatum ? url.searchParams.append("convertDatum", this.params.convertDatum) : undefined;
        return url.toString();
    }
    static FromConfig(locationID, moduleInstanceID, parameterID) {
        return new FEWSURL({
            startDateNumDaysPrevious: 14,
            endDateNumDaysInFuture: 2,
            forecast: true,
            locationIds: locationID,
            moduleInstanceID: moduleInstanceID,
            parameterIds: parameterID
        });
    }
    static FromForm(locationID, moduleInstanceID, parameterID, startTime, endTime) {
        let x = new FEWSURL({
            startDateNumDaysPrevious: NaN,
            endDateNumDaysInFuture: NaN,
            forecast: true,
            locationIds: locationID,
            moduleInstanceID: moduleInstanceID,
            parameterIds: parameterID
        });
        x.isRawDates = true;
        x.rawStartDate = startTime;
        x.rawEndDate = endTime;
        return x;
    }
}
